import ErrorMessage from "./ErrorMessage";

export default function PermissionErrorMessage() {
    return <ErrorMessage message={["נראה שאין לך הרשאה מתאימה"]} />;
}
